import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Loader2, Play } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Gallery = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await fetch(`${API}/gallery`);
        if (response.ok) {
          const data = await response.json();
          setItems(data);
        }
      } catch (error) {
        console.error('Error loading gallery:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []); // Empty dependency array is correct here - only fetch on mount

  if (loading) {
    return (
      <div className="min-h-screen py-20 px-4 flex items-center justify-center">
        <Loader2 className="h-12 w-12 text-cyan-400 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-20 px-4">
      <div className="container mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">
            Nuestros Trabajos
          </h1>
          <p className="text-xl text-slate-300">
            Mira algunos de los trabajos que hemos realizado
          </p>
        </div>

        {items.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-slate-400 text-lg">No hay trabajos para mostrar aún</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((item) => (
              <Card key={item.id} className="bg-slate-800/50 backdrop-blur-sm border-slate-700 hover:border-cyan-500/50 transition-all duration-300 hover:scale-[1.02] overflow-hidden">
                <div className="aspect-video overflow-hidden bg-slate-900 relative group cursor-pointer">
                  {item.type === 'video' ? (
                    <>
                      <img 
                        src={item.thumbnail_url || item.image_url} 
                        alt={item.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/50 transition-colors">
                        <Play className="h-16 w-16 text-white drop-shadow-lg" />
                      </div>
                      <a 
                        href={item.image_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="absolute inset-0"
                      />
                    </>
                  ) : (
                    <img 
                      src={item.image_url} 
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <CardContent className="p-4">
                  <h3 className="text-white font-semibold mb-2">{item.title}</h3>
                  {item.description && (
                    <p className="text-slate-400 text-sm">{item.description}</p>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
